export const FETCH_DATA_FOR_OFFER_SETTINGS =
  '[ Offers ] Fetch necessary data for the offer settings'

export const FETCH_OFFER = '[ Offers ] Fetch one offer'
export const FETCH_OFFERS = '[ Offers ] Fetch offers view model'
export const SEARCH_OFFERS = '[ Offers ] Search offers by given filters'

export const CLEAR_OFFER = '[ Offers ] Clear offer state'
export const CREATE_OFFER = '[ Offers ] Create offer'
export const REMOVE_OFFER = '[ Offers ] Remove offer'
export const UPDATE_OFFER = '[ Offers ] Update offer'

export const CREATE_OFFER_POST = '[ Offers ] Create a new post for an offer'
export const DELETE_OFFER_POST = '[ Offers ] Delete a post'
export const FETCH_OFFER_POSTS = '[ Offers ] Fetch posts of offer'
export const UPDATE_OFFER_POST = '[ Offers ] Update post'

export const FETCH_OFFER_PARTNERS = '[ Offers ] Fetch partners'
